export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";
export const RESET_AUTH = "RESET_AUTH";
export const ERROR = 'ERROR'
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS'
export const CLEARSIGNUP = 'CLEARSIGNUP'
export const CLEARERROR = 'CLEARERROR'
export const VERIFY_SUCCESS = 'VERIFY_SUCCESS'